import { gql } from '@apollo/client'
import { BASIC_BOUNDING_BOXES_FRAGMENT } from './BasicBoundingBoxesFragment'
import { BASIC_PRODUCT_FRAGMENT } from './BasicProductFragment'

export const BASIC_DISPLAY_AUDIT_IMAGE_FRAGMENT = gql`
  fragment BasicDisplayAuditImage on DisplayAuditImage {
    id
    url
    created
    boundingBoxSet {
      ...BasicBoundingBoxes
    }
    products {
      ...BasicProduct
    }
  }
  ${BASIC_BOUNDING_BOXES_FRAGMENT}
  ${BASIC_PRODUCT_FRAGMENT}
`
